import { useDocumentLanguage } from "@/i18n/useDocumentLanguage";
import { useRouteChangeFocus } from "@/routes/useRouteChangeFocus";

export function AppRuntimeEffects() {
  useDocumentLanguage();
  useRouteChangeFocus();

  return null;
}
